var _rect, _rect2, _text, _text2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLetterLogic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 16,
    width: 60,
    height: 68,
    rx: 6,
    fill: "#F9907B"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 20,
    width: 52,
    height: 60,
    rx: 4,
    fill: "#FAC1B5"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 46,
    y: 68,
    fontFamily: "sans-serif",
    fontSize: 52,
    fontWeight: "bold",
    fill: "#C75E5A",
    textAnchor: "middle"
  }, "L")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 68,
    y: 74,
    fontFamily: "sans-serif",
    fontSize: 12,
    fill: "#C75E5A",
    textAnchor: "middle"
  }, "1")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLetterLogic);
export default __webpack_public_path__ + "static/media/LetterLogic.ddd3f97b3c3a5d87b51d99a9e270905f.svg";
export { ForwardRef as ReactComponent };